export const useBrokenText = (text: string, textSize?: number): [string, string, boolean] => {
  const full = text;
  const splited = full.split('');
  const size = textSize || 33;
  const piece = splited.reduce((acc, cur, i) => {
    const el = i <= size ? cur : '';
    return acc + el;
  }, '');
  let isSmall = false;
  if (textSize) {
    isSmall = full.length <= textSize;
    return [piece, full, isSmall];
  }
  return [piece, full, isSmall];
};
